import React from 'react';
import { Typography } from 'src/components';

const FilterSetLabel = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography className="text-center justify-center text-primary text-lg font-bold font-['Inter'] leading-7">
      {children}
    </Typography>
  );
};

export default FilterSetLabel;
